import { render } from "./IndicadorCalidad.vue?vue&type=template&id=80dfb394"
import script from "./IndicadorCalidad.vue?vue&type=script&lang=js"
export * from "./IndicadorCalidad.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__